export type AccentToken =
  | 'primary.main'
  | 'secondary.main'
  | 'success.main'
  | 'warning.main'
  | 'info.main';

export const ACCENT_BG: Record<AccentToken, string> = {
  'primary.main': 'primary.50',
  'secondary.main': 'secondary.50',
  'success.main': 'var(--success-bg)',
  'warning.main': 'var(--warning-bg)',
  'info.main': 'primary.50',
};
